import { Avatar, Heading, Stack, Flex, InlineStack, Paragraph } from '@customerio/pluma-components/react';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import customerIoLogoForest from '@/assets/images/logos/logo-forest.svg';
import { Panel, PanelHeader, Image } from '@customerio/pluma-components/react';
import { useMemo } from 'react';
import { useAuthQuery } from '@/services/auth';

export const AuthLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const auth = useAuthQuery();

  const userInfo = useMemo(() => {
    const firstName = auth.data?.user?.first_name;
    const lastName = auth.data?.user?.last_name;
    const name = [firstName, lastName]
      .filter((name): name is string => typeof name === 'string' && name !== '')
      .join(' ');

    return {
      name,
      email: auth.data?.user?.email ?? undefined,
    };
  }, [auth.data?.user]);

  return (
    <Flex
      position="fixed"
      backgroundColor="base"
      alignItems="center"
      justifyContent="center"
      p="300"
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        minHeight: '100vh',
      }}
    >
      <Panel style={{ width: '100%', maxWidth: '600px', boxShadow: themeVars.depth['surface-2'] }}>
        <PanelHeader withBorder>
          <Image src={customerIoLogoForest} alt="Customer.io" width={160} />
          <InlineStack alignBlock="center" alignInline="space-between" gap="100">
            <Avatar name={userInfo.name} email={userInfo.email} statusIndicatorColor="success" />
            <Stack alignBlock="center">
              <Heading level="5">{userInfo.name}</Heading>
              <Paragraph variant="secondary" size="s">
                {userInfo.email}
              </Paragraph>
            </Stack>
          </InlineStack>
        </PanelHeader>
        {children}
      </Panel>
    </Flex>
  );
};
